import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-fg/10">
      <div className="container mx-auto px-6 py-8 text-center text-fg/50 text-sm">
        <p>2026 Combi.kz. {t('footer')}</p>
        <p className="text-xs mt-2 font-mono opacity-60">digital product lab since 2023</p>
        <div className="flex justify-center gap-4 mt-3">
          <Link to="/manage-data" className="text-xs hover:text-primary transition">
            {t('manageMyData')}
          </Link>
          <Link to="/privacy-policy" className="text-xs hover:text-primary transition">
            {t('privacyPolicy')}
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;